module.exports = __webpack_public_path__ + "static/img/DYSON-SHARP.2724e84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DYSON-SHARP.jpg
// module id = EvR1
// module chunks = 0